import { Box, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { MoreVertOutlined } from "@mui/icons-material";
import ForumComments from "./ForumComments";
import OnlineStatus from "../Common/OnlineStatus";
import dayjs from "dayjs";

const ForumCard = ({ item }) => {
  return (
    <Box mb={4}>
      <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
        <Stack direction={"column"}>
          <Stack direction={"row"} gap={2} alignItems={"center"}>
            <Typography
              sx={{
                color: "#fff",
                fontFamily: "Mulish-ExtraBold",
                fontSize: "24px",
              }}
            >
              {item?.title}
            </Typography>
            <OnlineStatus status={"Online"} />
          </Stack>
          <Typography
            sx={{
              color: colors.secondary,
              fontFamily: "Mulish-Bold",
              fontSize: "14px",
            }}
          >
            {"@" + item?.user?.firstName + " "}
          </Typography>
        </Stack>
        <IconButton>
          <MoreVertOutlined sx={{ color: "#fff" }} />
        </IconButton>
      </Stack>

      <Stack direction={"row"} alignItems={"center"} gap={2} mb={2}>
        <img
          src={item?.image_url}
          alt="forum"
          style={{
            width: "50%",
            height: "100%",
            borderRadius: "10px",
          }}
        />
        <Stack direction={"column"} gap={1}>
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-Medium",
              fontSize: "14px",
            }}
          >
            {item?.description}
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.5)",
              fontFamily: "Mulish-Regular",
              fontSize: "12px",
            }}
          >
            {dayjs(item?.createdAt).format("DD/MM/YYYY")}
          </Typography>
        </Stack>
      </Stack>

      <ForumComments forumData={item} />
    </Box>
  );
};

export default ForumCard;
